import React, { Component, Fragment } from 'react';
import { withTranslation } from 'react-i18next';
import { Helmet } from "react-helmet";
import {
  HeroBlock,
  GelContentContainer,
  GelContentRow,
  GelContentColumn,
  ApiPager,
  Link, Role,
  withFlashState, CheckboxElement, ButtonSecondary, Controls, withAuthentication, FormErrorSummary, Notices, withVenuesApi
} from "cw-styleguide-react";
import { route } from "../../../routes";
import VenuesManageFilterForm from "../components/VenuesManageFilterForm";
import { ROLE_PROVIDER, ROLE_STAFF } from "../../../constants";

class VenuesManageView extends Component {

  /**
   * Render.
   * @returns {JSX.Element}
   */
  render() {
    return (
      <Fragment>
        <Helmet>
          <title>{this.props.t('local:view.venues.manage.title')}</title>
        </Helmet>
        <GelContentContainer>
          <h1>{this.props.t('local:view.venues.manage.title')}</h1>
        </GelContentContainer>
        <HeroBlock>
          <p>{this.props.t('local:view.venues.manage.introduction')}</p>
        </HeroBlock>

        <GelContentContainer>

          <Notices messages={this.props.messages} />
          <FormErrorSummary errors={this.props.formErrors} />

          <Controls>
            <ButtonSecondary url={route('venuesCreate')} title={this.props.t('local:view.venues.manage.controls.create')}>{this.props.t('local:view.venues.manage.controls.create')}</ButtonSecondary>
            <Role roles={[ROLE_STAFF]}>
              <ButtonSecondary disabled={!this.props.selected.size} onClick={() => {this.props.toggleModal(['bulkDelete'], true)}} title={this.props.t('local:view.venues.manage.controls.delete')}>{this.props.t('local:view.venues.manage.controls.delete')}</ButtonSecondary>
              <ButtonSecondary disabled={!this.props.selected.size} onClick={() => {this.props.toggleModal(['bulkArchive'], true)}} title={this.props.t('local:view.venues.manage.controls.archive')}>{this.props.t('local:view.venues.manage.controls.archive')}</ButtonSecondary>
            </Role>
            <Role roles={[ROLE_STAFF, ROLE_PROVIDER]}>
              <ButtonSecondary disabled={!this.props.selected.size} onClick={() => {this.props.toggleModal(['bulkRollback'], true)}} title={this.props.t('local:view.venues.manage.controls.rollback')}>{this.props.t('local:view.venues.manage.controls.rollback')}</ButtonSecondary>
            </Role>
          </Controls>

          <GelContentRow>
            <GelContentColumn xs={12} sm={12} md={4} lg={4} mdPush={8} lgPush={8}>
              <VenuesManageFilterForm values={this.props.filterValues} handleChange={this.props.handleChange} handleSubmit={this.props.handleSubmit} handleReset={this.props.handleReset} />
            </GelContentColumn>

            <GelContentColumn xs={12} sm={12} md={8} lg={8} mdPull={4} lgPull={4}>
              <ApiPager
                api={this.props.venuesApiGetEndpoint('venues_api_venues_q')}
                filters={{
                  statuses: this.props.filterValues.status,
                  venueName: this.props.filterValues.venueName,
                  postCode: this.props.filterValues.postCode,
                  townCity: this.props.filterValues.townCity,
                  translatorAssigned: this.props.filterValues.translatorAssigned,
                }}
                sortOptions={[
                  {
                    value: 'rel',
                    label: this.props.t('styleguide:forms.order.options.rel')
                  },
                  {
                    value: 'asc',
                    label: this.props.t('styleguide:forms.order.options.asc')
                  },
                  {
                    value: 'desc',
                    label: this.props.t('styleguide:forms.order.options.desc')
                  }
                ]}
                // handleStateChange={() => {
                //   this.props.clearSelected();
                //   // this.props.clearMessages(); removed to prevent hiding success message (https://dev.azure.com/ccdg/CWO%20-%20Courses/_workitems/edit/9938)
                // }}
                handleStateChange={this.props.handleStateChange}
                initialOrder={this.props.filterValues['order']}
                initialPage={this.props.filterValues['page']}
                initialGroupSize={this.props.filterValues['groupSize']}
                autoReload={false}
                reloadKey={this.props.reloadKey}
                onReloadResetPage={true}
                noResultsText={this.props.t('styleguide:messages.noResults')}
                hasResultsText={''}
                table={true}
                tableHeader={() => (
                  <tr>
                    <th>{this.props.t('local:view.venues.manage.tableHeader.select')}</th>
                    <th>{this.props.t('local:view.venues.manage.tableHeader.name')}</th>
                    <th>{this.props.t('local:view.venues.manage.tableHeader.postcode')}</th>
                    <th>{this.props.t('local:view.venues.manage.tableHeader.townCity')}</th>
                  </tr>
                )}
                render={(venue) => (<tr>
                  <td><CheckboxElement onChange={this.props.handleBulkCheckbox} checked={this.props.selected.has(venue.venueId)} value={venue.venueId} /></td>
                  <td>  <Link to={route('venuesEdit', { "venue": venue.venueId })}>{venue.venueName}</Link></td>
                  <td> {venue.postCode}</td>
                  <td>{venue.townCity}</td>
                </tr>)} />
            </GelContentColumn>
          </GelContentRow>
        </GelContentContainer>
      </Fragment>

    )
  }

}

export default withVenuesApi(process.env)(withAuthentication(withFlashState(withTranslation('local')(VenuesManageView))));
